import { c as _c } from "react/compiler-runtime";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { RatingsSectionProps, RatingsData, ThemeColors } from "./types";
interface ParticipationDropRatingsUserSectionProps extends RatingsSectionProps {
  readonly ratingsData: RatingsData;
  readonly drop: ApiDrop;
  readonly userTheme: ThemeColors;
}
export default function ParticipationDropRatingsUserSection(t0) {
  const $ = _c(15);
  const {
    drop,
    userTheme,
    ratingsData
  } = t0;
  const {
    userRating
  } = ratingsData;
  if (userRating === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="tw-text-sm tw-font-normal tw-text-iron-500">Your votes</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `tw-relative ${userTheme.indicator}`;
  const t3 = `tw-text-sm tw-font-semibold ${userTheme.text}`;
  const t4 = userRating < 0 && "-";
  let t5;
  if ($[1] !== userRating) {
    t5 = formatNumberWithCommas(Math.abs(userRating));
    $[1] = userRating;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== t3 || $[4] !== t4 || $[5] !== t5) {
    t6 = <span className={t3}>{t4}{t5}</span>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t6) {
    t7 = <div className={t2}>{t6}</div>;
    $[7] = t2;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== drop.wave.voting_credit_type) {
    t8 = <span className="tw-text-sm tw-font-normal tw-text-iron-500">{drop.wave.voting_credit_type}</span>;
    $[10] = drop.wave.voting_credit_type;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-1">{t1}{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}